import authReducer from "./authReducer";
import categoriesReducer from "./categoriesReducer";
import sessionsReducer from "./sessionsReducer";
import authorsReducer from "./authorsReducer";
import tappingPointsReducer from "./tappingPointsReducer";
import quotesReducer from "./quotesReducer";
import mediaReducer from "./mediaReducer";
import subcategoriesReducer from "./subcategoriesReducer";
import tagsReducer from "./tagsReducer";
import feedbacksReducer from "./feedbacksReducer";
import requestsReducer from "./requestsReducer";
import promoBannerReducer from "./promoBannerReducer";
import promoDataReducer from "./promoDataRedurer";
import generalDataReducer from "./generalDataReducer";
import generalInfoReducer from "./generalInfoReducer";
import onboardingDataReducer from "./onboardingReducer";
import seriesReducer from "./seriesReducer";
import challengesReducer from "./challengesReducer";
import searchReducer from "./searchReducer";
import dailyReflectionReducer from "./dailyReflectionReducer";
import backgroundMusicReducer from "./backgroundMusicReducer";
import playerAssetReducer from "./playerAssetReducer";
import cancellationReducer from "./cancellationReducer";
import userCancellationReducer from "./userCancellationReducer";
import quickTapsReducer from "./quickTapsReducer";
import highlightReducer from "./highlightReducer";
import streakReducer from "./streakReducer";
import cardDecksReducer from "./cardDecksReducer";
import cardsReducer from "./cardsReducer";
import mediaResourcesReducer from "./mediaResourcesReducer";
import adminsReducer from "./adminsReducer";
import marketingInitiativeReducer from "./marketingInitiativeReducer";
import rolesReducer from "./rolesReducer";
import permissionsReducer from "./permissionsReducer";
import dashboardReducer from "./dashboardReducer";
import attributionOptionsReducer from "./attributionOptionsReducer";
import recommendedListReducer from "./recommendedListReducer";
import topicSessionListReducer from "./topicSessionListReducer";
import popularListReducer from "./popularListReducer";
import captionsReducer from "./captionsReducer";
import experimentsReducer from "./experimentsReducer";
import goalContentReducer from "./goalContentReducer";

const rootReducer = {
  auth: authReducer,
  dashboard: dashboardReducer,
  categories: categoriesReducer,
  sessions: sessionsReducer,
  authors: authorsReducer,
  tapping_points: tappingPointsReducer,
  quotes: quotesReducer,
  media: mediaReducer,
  subcategories: subcategoriesReducer,
  tags: tagsReducer,
  feedbacks: feedbacksReducer,
  requests: requestsReducer,
  banners: promoBannerReducer,
  promo_data: promoDataReducer,
  general_data: generalDataReducer,
  general_info: generalInfoReducer,
  onboarding_data: onboardingDataReducer,
  series: seriesReducer,
  challenges: challengesReducer,
  search: searchReducer,
  background_musics: backgroundMusicReducer,
  player_assets: playerAssetReducer,
  daily_reflections: dailyReflectionReducer,
  cancellation_reasons: cancellationReducer,
  user_cancellations: userCancellationReducer,
  quick_taps: quickTapsReducer,
  highlight_index: highlightReducer,
  user_streak: streakReducer,
  card_decks: cardDecksReducer,
  cards: cardsReducer,
  mediaResources: mediaResourcesReducer,
  admins: adminsReducer,
  initiatives: marketingInitiativeReducer,
  roles: rolesReducer,
  permissions: permissionsReducer,
  attribution_options: attributionOptionsReducer,
  recommended_list: recommendedListReducer,
  topic_session_list: topicSessionListReducer,
  popular_list: popularListReducer,
  captions: captionsReducer,
  experiments: experimentsReducer,
  goalContent: goalContentReducer,
};

export default rootReducer;
